import * as $ from 'jquery';

// We use a custom event because we never want to trigger a native event
export const customActivateItemEventName = 'activate-item';

// Helper method that detects whether an element was "activated"
// Returns a function that you can execute to remove the listeners
// Accessibility in mind: click, spacebar, enter
const spacebarKey = 32;
const enterKey = 13;
export default function elementOnActivate(elements: JQuery<HTMLElement>, cb: () => void) {
	const $elements = $(elements);

	const handler = (e: any, ...args: any[]) => {
		// If click or spacebar, or enter is pressed
		if (
			e.type === customActivateItemEventName ||
			e.type === 'click' ||
			(e.type === 'keydown' && (e.keyCode === spacebarKey || e.keyCode === enterKey))
		) {
			cb.call(this, e, ...args);
		}
	};
	$elements.on(`${customActivateItemEventName} click keydown`, handler);

	return function() {
		$elements.off('click keydown', handler);
	};
};
